import SidebarButton from '@activities/MainActivity/components/MainLayout/Sidebar/SidebarHeader/SidebarButton';
import Row from '@components/Row';
import Text from '@components/Text';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import useInquiryInfo from '@hooks/inquiry/useInquiryInfo';
import useProject from '@hooks/useProject';
import BarcodeIcon from '@icons/BarcodeIcon';
import CsIcon from '@icons/CsIcon';
import SettingIcon from '@icons/SettingIcon';
import { useTranslation } from 'react-i18next';

function SidebarHeader() {
    const { inquiryEnabled } = useInquiryInfo();
    const { t } = useTranslation('main', { keyPrefix: 'sidebar' });
    const project = useProject();
    return (
        <Container>
            <Row fullWidth justify='space-between' spacing={5}>
                <Text fontWeight='bold' size='display' css={css`
                    white-space: wrap;
                    word-break: break-all;
                `}>
                    {t('userName', { name: project?.name || t('defaultName') })}
                </Text>
                <Text>
                    {t('close')}
                </Text>
            </Row>
            <Row spacing={2} align='stretch'>
                <Wrapper>
                    <SidebarButton label={t('membershipBarcode')}
                        icon={BarcodeIcon}/>
                </Wrapper>
                {inquiryEnabled && (
                    <Wrapper>
                        <SidebarButton label={t('serviceCenter')}
                            icon={CsIcon}/>
                    </Wrapper>
                )}
                <Wrapper>
                    <SidebarButton label={t('accountSetting')}
                        icon={SettingIcon} />
                </Wrapper>
            </Row>
        </Container>
    );
}

const Container = styled.div`
    padding: calc(64px +  var(--safe-area-top)) 16px 24px;
    width: 100%;
    display: flex;
    flex-direction: column;
    row-gap: 32px;
`;

const Wrapper = styled.div`
    width: 100%;
`;

export default SidebarHeader;
